<template>
  <b-container class="container" id="splash-container" fluid>
    <!-- <language-selection class="language" :locale="'en'"></language-selection> -->
    <b-container class="login-area">
      <b-row
        class="login-buttons splash-container position-relative login-form"
        align-v="center"
      >
        <div id="login-logo-container"></div>
        <login-helper
          v-bind:isPopup="false"
          @guestLogin="loginAsGuest()"
        ></login-helper>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import Config from "../config/index";
import LoginHelper from "../components/LoginHelper";

export default {
  name: "Login",
  components: {
    LoginHelper
  },
  data() {
    return {
      game: null,
      recovery: {
        reset_token: null,
        email: null
      }
    };
  },
  computed: {},
  methods: {
    loginAsGuest() {
      this.$store
        .dispatch("loginGuest")
        .then(() => {
          this.$router.push(`/${this.$route.params.game}/play`);
        })
        .catch(err => console.log(err));
    }
  },
  beforeMount() {
    this.game = this.$store.getters.getGame;
  },
  mounted() {
    const splashContainer = document.getElementById("splash-container");
    splashContainer.style.backgroundImage = `url('${Config.ASSET_URL}/game/images/${this.game.gameName}/landing_page/lp_background.jpg'`;

    const imgLogoContainer = document.getElementById("login-logo-container");
    imgLogoContainer.style.backgroundImage = `url('${Config.ASSET_URL}/game/images/${this.game.gameName}/login/logo.png'`;
  }
};
</script>
